import { render, staticRenderFns } from "./ModalUserForm.vue?vue&type=template&id=8ba4899e&scoped=true&"
import script from "./ModalUserForm.vue?vue&type=script&lang=js&"
export * from "./ModalUserForm.vue?vue&type=script&lang=js&"
import style0 from "./ModalUserForm.vue?vue&type=style&index=0&id=8ba4899e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba4899e",
  null
  
)

export default component.exports